<div class="row py-3 justify-content-center">
  <!-- Expense date range -->
  <div class="col-auto text-center">
    <mat-form-field>
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [formControl]="daterangeStartForm" placeholder="Start date" (dateChange)="daterangeUpdate()">
        <input matEndDate [formControl]="daterangeEndForm" placeholder="End date" (dateChange)="daterangeUpdate()">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <button matMiniFab class="narrow-button ms-2" (click)="resetDates()" matTooltip="Reset to Data Date">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <div class="col-auto">
    <mat-form-field>
      <mat-label>Version</mat-label>
      <mat-select [(ngModel)]="selectedVersion" (selectionChange)="update()">
        @for (version of versions; track version) {
          <mat-option [value]="version">{{ version }}</mat-option>
        }
        </mat-select>
    </mat-form-field>
  </div>

  <div class="col-auto">
    <mat-form-field>
      <mat-label>Request Type</mat-label>
      <mat-select [(ngModel)]="selectedRequestType" (selectionChange)="update()">
        <mat-option [value]=""></mat-option>
        @for (type of requestTypes; track type) {
          <mat-option [value]="type">{{ type }}</mat-option>
        }
        </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="row">
  <div appFillHeight class="table-responsive">
    <table mat-table [dataSource]="routeAverage" matSort>
      <ng-container matColumnDef="route">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Route</th>
        <td mat-cell *matCellDef="let element"> {{element.route}} </td>
      </ng-container>
      <ng-container matColumnDef="average">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Average</th>
        <td mat-cell *matCellDef="let element"> {{element.average | number:'.5-5' }} </td>
      </ng-container>
      <ng-container matColumnDef="records">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Records</th>
        <td mat-cell *matCellDef="let element"> {{element.records}} </td>
      </ng-container>
      <ng-container matColumnDef="min">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Min</th>
        <td mat-cell *matCellDef="let element"> {{element.min | number:'.5-5' }} </td>
      </ng-container>
      <ng-container matColumnDef="max">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Max</th>
        <td mat-cell *matCellDef="let element"> {{element.max | number:'.5-5' }} </td>
      </ng-container>
      <ng-container matColumnDef="sd">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Std Dev.</th>
        <td mat-cell *matCellDef="let element"> {{element.sd | number:'.5-5' }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="routaAverageColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: routaAverageColumns;"></tr>
    </table>
  </div>
</div>